import React, { FC } from 'react';
import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getAuthState } from '../../ducks/auth/selectors';
import { AuthState } from '../../ducks/auth/slice';
import { Snackbar } from '../../components/Snackbar';

export const AuthorizationRoute: FC<RouteProps> = ({ children, ...props }) => {
  const location = useLocation<{ from: string }>();
  const authState = useSelector(getAuthState);

  if (authState === AuthState.AUTHORIZED) {
    return (
      <Redirect
        to={{
          pathname: location.state?.from || '/',
        }}
      />
    );
  }

  if ([AuthState.CHECKING, AuthState.DISCONNECTED].includes(authState)) {
    return <Route {...props}>{children}</Route>;
  }

  if (authState === AuthState.GUEST) {
    return (
      <Route {...props}>
        {children}
        {<Snackbar type="error" title="Not authorized" content="This wallet is not authorized, please register" />}
      </Route>
    );
  }

  return <Route {...props}>{children}</Route>;
};
